import { Formik } from "formik"
import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import axios from "axios"
import { useHistory } from "react-router-dom"

const AVAddNewQuotation = ({ newQuotationToggle, editing, setEditing }) => {
  const userID = localStorage.getItem("id")
  const [modal, setModal] = useState(true)
  const toggle = () => {
    newQuotationToggle()
  }

  const onClose = () => {
    newQuotationToggle()
  }

  const history = useHistory()

  const [projectCost, setProjectCost] = useState("")
  const [projectData, setProjectData] = useState("")
  const [referenceNo, setReferenceNo] = useState("")

  const [projectNoType, setProjectNoType] = useState()
  const [projectNo, setProjectNo] = useState("")
  const [projectID, setProjectID] = useState("")
  const [projectNoError, setProjectNoError] = useState(
    "valid project no. required!"
  )

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ReferenceNo: projectNo,
    }

    if (projectNoType === "ref") {
      formData.ReferenceNo = projectNo
      delete formData.RequestID
      delete formData.PolicyNo
    } else if (projectNoType === "request") {
      formData.RequestID = projectNo
      delete formData.ReferenceNo
      delete formData.PolicyNo
    } else if (projectNoType === "policy") {
      formData.PolicyNo = projectNo
      delete formData.ReferenceNo
      delete formData.RequestID
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/ProjectCostView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        if (res.data.error === true) {
          setProjectNoError("valid project no. required!")
        }

        // console.log("res===========>", res)

        if (res.data.error === false) {
          if (!res.data.ProjectID) {
            setProjectNoError("valid project no. required!")
          } else {
            setProjectNoError("")
          }

          setProjectCost(res.data.Cost)
          setProjectID(res.data.ProjectID)
          setProjectData(res.data)
        }
      })
      .catch(err => console.log(err))
  }, [projectNo, projectNoType])

  const RD7PercentageHandler = (WP, G, S) => {
    if (WP === true) {
      return 0.45
    } else if (projectCost <= 800000 && G > 0 && S === 0) {
      return 0.15
    } else if (projectCost <= 800000 && G > 0 && S > 0) {
      return 0.25
    } else if (projectCost > 800000) {
      return G * 0.0015 + S * 0.001
    } else {
      return ""
    }
  }

  const RD7CostHandler = (WP, G, S, RD7CostPer) => {
    if (WP === true) {
      return Math.max(3600, (0.45 * projectCost) / 115)
    } else if (S === 0) {
      return Math.max(1200, (RD7CostPer * projectCost) / 115)
    } else if (S > 0) {
      return Math.max(2000, (RD7CostPer * projectCost) / 115)
    } else {
      return ""
    }
  }

  const submitHandler = (values, onSubmitProps) => {
    // if (!projectCost) return

    // onSubmitProps.resetForm()

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: projectID,
      AVCost: 600,
      VAT: 90,
      AVTotal: 690,
    }

    console.log("formData", formData)

    axios
      .post(
        process.env.REACT_APP_API_URL + "api/AV/AddAVQuotation.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          history.push("/logout")
        }

        // console.log("res", res)
        setEditing(!editing)
      })
      .catch(err => console.log(err))
    onClose()
  }

  return (
    <div>
      <Modal className="modal-lg" isOpen={modal} toggle={toggle}>
        <ModalHeader>
          New Quotation{" "}
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            onClick={onClose}
          />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={6}>
              <Row className="mx-1 mb-3">
                {/* ******************************* Reference No ************************************* */}
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="radioGroup"
                      value="ref"
                      onClick={e => setProjectNoType(e.target.value)}
                    />
                    Reference No
                  </Label>
                </FormGroup>

                {/* ******************************* Request No ************************************* */}
                <FormGroup check className="my-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="radioGroup"
                      value="request"
                      onClick={e => setProjectNoType(e.target.value)}
                    />
                    Request No
                  </Label>
                </FormGroup>

                {/* ******************************* Policy No ************************************* */}
                <FormGroup check className="my-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="radioGroup"
                      value="policy"
                      onClick={e => setProjectNoType(e.target.value)}
                    />
                    Policy No
                  </Label>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup>
                  <Input
                    disabled={!projectNoType}
                    type="number"
                    name="ProjectNo"
                    value={projectNo}
                    onChange={e => {
                      setProjectNo(e.target.value)
                    }}
                  />

                  <p className="error px-1 w-100">{projectNoError}</p>

                  {/* {!projectCost ? (
                    <p className="error px-1 w-100">
                      valid reference no. required
                    </p>
                  ) : null} */}
                </FormGroup>
              </Row>
            </Col>

            <Formik
              initialValues={{}}
              // enableReinitialize
              validateOnBlur
              validateOnChange
              validate={values => {
                let errors = {}
                console.log("values ========>", values)

                console.log("errors", errors)
                return errors
              }}
              onSubmit={submitHandler}
            >
              {props =>
                projectID && (
                  <Form onSubmit={props.handleSubmit}>
                    <Row>
                      <Label className="d-flex align-items-center mt-2 ">
                        Owner Name :{" "}
                        <Col sm={5} className="ms-5">
                          <b> {projectData.OwnerName || "__"}</b>
                        </Col>
                      </Label>
                    </Row>
                    <Row>
                      <Label className="d-flex align-items-center mt-2 ">
                        Contractor Name :
                        <Col sm={5} className="ms-3">
                          <b> {projectData.ConstructorName || "__"}</b>
                        </Col>
                      </Label>
                    </Row>
                    <FormGroup className="d-flex ms-auto col-3 mt-5 justify-content-around">
                      <Button
                        onClick={() => {
                          onClose()
                        }}
                        className="bg-primary"
                      >
                        close
                      </Button>
                      <Button type="submit" className="bg-primary">
                        Submit
                      </Button>
                    </FormGroup>
                  </Form>
                )
              }
            </Formik>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AVAddNewQuotation
